import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { AFAddressHistoryDomain, OusData, AFCpaInfo } from "../model/af.model";
import { AuthService } from "./auth.service";
import { DateFormatPipe } from "./dateFormatPipe";
import moment from "moment";

@Injectable({
  providedIn: "root",
})
export class AddressService {
  constructor(
    private userService: AuthService,
    private http: HttpClient,
    private dt: DateFormatPipe
  ) { }

  getAddressHistory(): Observable<AFAddressHistoryDomain> {
    return this.http
      .post<AFAddressHistoryDomain>(environment.api_uri + "getAddressHistory", {
        verifyId: this.userService.getVerifyId(),
      })
      .pipe(
        map((response) => {
          response.addressList.forEach((item) => {
            if (item.startDate) {
              if (item.startDate) {
                item.startDate = new Date(item.startDate);
              }
              if (item.endDate) {
                item.endDate = new Date(item.endDate);
              }
            }
            if (item.usState) {
              item.usState = item.usState + "";
            }
          });
          return response;
        })
      );
  }

  getOusData(countryList, countryId): Observable<OusData> {
    const requestUrl = environment.api_uri + "getOusData";
    let data = new OusData();
    data.countryId = countryId;
    data.countryList = countryList;

    return this.http.post<OusData>(requestUrl, data);
  }

  submitAddressHistory(
    AFAddressHistoryDomain
  ): Observable<AFAddressHistoryDomain> {
    const requestUrl = environment.api_uri + "saveAddress";

    AFAddressHistoryDomain.addressList.forEach((item) => {
      if (item.startDate) {
        if (item.startDate) {
          item.startDate = moment(item.startDate).format("MM/DD/YYYY");
        }
        if (item.endDate) {
          item.endDate = moment(item.endDate).format("MM/DD/YYYY");
        }
      }
    });

    return this.http.post<AFAddressHistoryDomain>(
      requestUrl,
      AFAddressHistoryDomain
    );
  }

  getCpaHistory(): Observable<AFCpaInfo> {
    let afId: number = Number(this.userService.getAfId());
    const applicantCpaStates = sessionStorage.getItem("cpa_states");
    let cpaStates: string[] = [];
    let cpaStatesNum: number[] = [];

    if (applicantCpaStates) {
      cpaStates = JSON.parse(applicantCpaStates);

      if (cpaStates && cpaStates.length > 0) {
        cpaStatesNum = cpaStates.map((str) => Number(str));
      }
    }

    return this.http.get<AFCpaInfo>(
      environment.api_uri +
      "getCpaHistory?verifyId=" +
      this.userService.getVerifyId() +
      "&afId=" +
      afId +
      "&cpaStates=" +
      cpaStatesNum
    );
  }

  submitCpaHistory(afCpaInfo): Observable<AFCpaInfo> {
    const requestUrl = environment.api_uri + "saveCpaHistory";
    return this.http.post<AFCpaInfo>(requestUrl, afCpaInfo);
  }

  removeAttachment(attachmentId: string): Observable<string> {
    const requestUrl = environment.api_uri + "removeAttachment";
    const fd = new FormData();
    fd.append("attachmentId", attachmentId);
    return this.http.post<string>(requestUrl, fd);
  }

  removeAddressHisAttachment(ousAttachmentID: string): Observable<string> {
    const requestUrl = environment.api_uri + "removeAddressHisAttachment";
    const fd = {
      verifyId: this.userService.getVerifyId(),
      ousAttachmentID: ousAttachmentID,
    };
    return this.http.post<string>(requestUrl, fd);
  }
}
